import { Rect } from '../../primitives/rect';
import { isLabelFlipped } from '../../utility/diagram-util';
import { Quad } from './quad';
/**
 * Spatial search module helps to effectively find the objects over diagram
 */
export class SpatialSearch {
    /**
     *  Constructor for creating the spatial search
     *
     * @param {number} objectTable The objectTable.
     * @private
     */
    constructor(objectTable) {
        this.quadSize = 500;
        this.objectTable = objectTable;
        this.parentQuad = new Quad(0, 0, this.quadSize * 2, this.quadSize * 2, this);
        this.pageLeft = Number.MAX_VALUE;
        this.pageRight = -Number.MAX_VALUE;
        this.pageTop = Number.MAX_VALUE;
        this.pageBottom = -Number.MAX_VALUE;
        this.quadTable = {};
    }
    /**
     * removeFromAQuad method\
     *
     * @returns {void}    removeFromAQuad method .\
     * @param {IGroupable} node - provide the options value.
     * @private
     */
    removeFromAQuad(node) {
        if (this.quadTable[node.id]) {
            const quad = this.quadTable[node.id];
            const index = this.objectIndex(quad.objects, node);
            if (index !== -1) {
                quad.objects.splice(index, 1);
                this.update(quad);
                delete this.quadTable[node.id];
            }
        }
    }
    update(quad) {
        //EJ2-841966-Nodes disappears while enabling virtualization constrai
        if (quad.parent && quad.objects.length === 0 && quad.first == null && quad.second == null
            && quad.third == null && quad.fourth == null) {
            const parent = quad.parent;
            if (parent.first === quad) {
                parent.first = null;
            }
            else if (parent.second === quad) {
                parent.second = null;
            }
            else if (parent.third === quad) {
                parent.third = null;
            }
            else if (parent.fourth === quad) {
                parent.fourth = null;
            }
            this.update(quad.parent);
        }
        else {
            if (quad === this.parentQuad && !quad.first && !quad.second && !quad.third && !quad.fourth) {
                quad.left = 0;
                quad.width = 1000;
                quad.top = 0;
                quad.height = 1000;
            }
            return;
        }
    }
    addIntoAQuad(node) {
        const quad = this.parentQuad.addIntoAQuad(node);
        this.quadTable[node.id] = quad;
    }
    objectIndex(objects, node) {
        for (let i = 0; i < objects.length; i++) {
            if ((objects[parseInt(i.toString(), 10)]).id === node.id) {
                return i;
            }
        }
        return -1;
    }
    updateQuad(node) {
        this.setCurrentNode(node);
        const nodBounds = node.outerBounds;
        if (!(!isNaN(nodBounds.x) && !isNaN(nodBounds.y) &&
            !isNaN(nodBounds.width) && !isNaN(nodBounds.height))) {
            return false;
        }
        //nodBounds = new Rect(nodBounds.X.Valid(), nodBounds.Y.Valid(), nodBounds.Width.Valid(), nodBounds.Height.Valid());
        if (this.quadTable[node.id]) {
            const quad = this.quadTable[node.id];
            if (!quad.isContained()) {
                this.removeFromAQuad(node);
                this.addIntoAQuad(node);
            }
        }
        else {
            this.addIntoAQuad(node);
        }
        if (this.isWithinPageBounds(nodBounds) &&
            this.leftElement !== node &&
            this.topElement !== node &&
            this.rightElement !== node &&
            this.bottomElement !== node) {
            //contained - no change
        }
        else {
            let modified = false;
            if (this.pageLeft !== this.childLeft || node !== this.leftElement) {
                if (this.pageLeft >= this.childLeft) {
                    this.pageLeft = this.childLeft;
                    this.leftElement = node;
                    modified = true;
                }
                else if (node === this.leftElement) {
                    this.pageLeft = Number.MAX_VALUE;
                    this.findLeft(this.parentQuad);
                    modified = true;
                }
            }
            if (this.pageTop !== this.childTop || node !== this.topElement) {
                if (this.pageTop >= this.childTop) {
                    this.pageTop = this.childTop;
                    this.topElement = node;
                    modified = true;
                }
                else if (node === this.topElement) {
                    this.pageTop = Number.MAX_VALUE;
                    this.findTop(this.parentQuad);
                    modified = true;
                }
            }
            if (this.pageBottom !== this.childBottom || node !== this.bottomElement) {
                if (this.pageBottom <= this.childBottom) {
                    modified = true;
                    this.pageBottom = this.childBottom;
                    this.bottomElement = node;
                }
                else if (node === this.bottomElement) {
                    this.pageBottom = -Number.MAX_VALUE;
                    this.findBottom(this.parentQuad);
                    modified = true;
                }
            }
            if (this.pageRight !== this.childRight || node !== this.rightElement) {
                if (this.pageRight <= this.childRight) {
                    this.pageRight = this.childRight;
                    this.rightElement = node;
                    modified = true;
                }
                else if (node === this.rightElement) {
                    this.pageRight = -Number.MAX_VALUE;
                    this.findRight(this.parentQuad);
                    modified = true;
                }
            }
            return modified;
        }
        this.setCurrentNode(null);
        return false;
    }
    isWithinPageBounds(node) {
        if (node.left >= this.pageLeft && node.right <= this.pageRight && node.top >= this.pageTop
            && node.bottom <= this.pageBottom) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * findQuads method\
     *
     * @returns {  Quad[] }    findQuads method .\
     * @param {Rect} region - provide the options value.
     * @private
     */
    findQuads(region) {
        const quads = [];
        this.parentQuad.findQuads(region, quads);
        return quads;
    }
    /**
     * findObjects method\
     *
     * @returns {  IGroupable[] }    findObjects method .\
     * @param {Rect} region - provide the options value.
     * @private
     */
    findObjects(region) {
        const quads = this.findQuads(region);
        const objects = [];
        for (const quad of quads) {
            for (const obj of quad.objects) {
                if (obj.outerBounds.intersects(region) || isLabelFlipped(obj)) {
                    objects.push(this.objectTable[obj.id]);
                }
            }
        }
        return objects;
    }
    /**
     * updateBounds method\
     *
     * @returns { boolean }    updateBounds method .\
     * @param {IGroupable} node - provide the options value.
     * @param {boolean} isSwimLane - provide boolean if its swimlane container
     * @private
     */
    updateBounds(node, isSwimLane) {
        let modified = false;
        //879088: Swimalane exception when drag and dropped from palette
        if (isSwimLane) {
            if (this.topElement && node.id === this.topElement.id) {
                modified = this.updateTop();
            }
            if (this.leftElement && node.id === this.leftElement.id) {
                modified = this.updateLeft();
            }
            if (this.rightElement && node.id === this.rightElement.id) {
                modified = this.updateRight();
            }
            if (this.bottomElement && node.id === this.bottomElement.id) {
                modified = this.updateBottom();
            }
        }
        else {
            if (node === this.topElement) {
                modified = this.updateTop();
            }
            if (node === this.leftElement) {
                modified = this.updateLeft();
            }
            if (node === this.rightElement) {
                modified = this.updateRight();
            }
            if (node === this.bottomElement) {
                modified = this.updateBottom();
            }
        }
        return modified;
    }
    updateTop() {
        this.pageTop = Number.MAX_VALUE;
        this.topElement = null;
        this.findTop(this.parentQuad);
        return true;
    }
    updateBottom() {
        this.pageBottom = -Number.MAX_VALUE;
        this.bottomElement = null;
        this.findBottom(this.parentQuad);
        return true;
    }
    updateLeft() {
        this.pageLeft = Number.MAX_VALUE;
        this.leftElement = null;
        this.findLeft(this.parentQuad);
        return true;
    }
    updateRight() {
        this.pageRight = -Number.MAX_VALUE;
        this.rightElement = null;
        this.findRight(this.parentQuad);
        return true;
    }
    findBottom(quad) {
        //if (quad.Quads.Count === 4)
        {
            if (quad.third || quad.fourth) {
                if (quad.third) {
                    this.findBottom(quad.third);
                }
                if (quad.fourth) {
                    this.findBottom(quad.fourth);
                }
            }
            else {
                if (quad.second) {
                    this.findBottom(quad.second);
                }
                if (quad.first) {
                    this.findBottom(quad.first);
                }
            }
        }
        for (const node of quad.objects) {
            if (this.pageBottom <= node.outerBounds.bottom) {
                this.pageBottom = node.outerBounds.bottom;
                this.bottomElement = node;
            }
        }
    }
    findRight(quad) {
        //if (quad.Quads.Count === 4)
        {
            if (quad.second || quad.fourth) {
                if (quad.second) {
                    this.findRight(quad.second);
                }
                if (quad.fourth) {
                    this.findRight(quad.fourth);
                }
            }
            // EJ2-65880 - Exception occurs on dragging outside the canvas
            {
                if (quad.first) {
                    this.findRight(quad.first);
                }
                if (quad.third) {
                    this.findRight(quad.third);
                }
            }
        }
        for (const node of quad.objects) {
            if (this.pageRight <= node.outerBounds.right) {
                this.pageRight = node.outerBounds.right;
                this.rightElement = node;
            }
        }
    }
    findLeft(quad) {
        //if (quad.Quads.Count === 4)
        {
            if (quad.first || quad.third) {
                if (quad.first) {
                    this.findLeft(quad.first);
                }
                if (quad.third) {
                    this.findLeft(quad.third);
                }
            }
            else {
                if (quad.second) {
                    this.findLeft(quad.second);
                }
                if (quad.fourth) {
                    this.findLeft(quad.fourth);
                }
            }
        }
        for (const node of quad.objects) {
            if (this.pageLeft >= node.outerBounds.left) {
                this.pageLeft = node.outerBounds.left;
                this.leftElement = node;
            }
        }
    }
    findTop(quad) {
        //if (quad.Quads.Count === 4)
        {
            if (quad.first || quad.second) {
                if (quad.first) {
                    this.findTop(quad.first);
                }
                if (quad.second) {
                    this.findTop(quad.second);
                }
            }
            else {
                if (quad.third) {
                    this.findTop(quad.third);
                }
                if (quad.fourth) {
                    this.findTop(quad.fourth);
                }
            }
        }
        for (const node of quad.objects) {
            if (this.pageTop >= node.outerBounds.top) {
                this.pageTop = node.outerBounds.top;
                this.topElement = node;
            }
        }
    }
    /**
     * setCurrentNode method\
     *
     * @returns { void }    setCurrentNode method .\
     * @param {IGroupable} node - provide the options value.
     * @private
     */
    setCurrentNode(node) {
        this.childNode = node;
        if (node) {
            const r = node.outerBounds;
            this.childLeft = Number(r.left);
            this.childTop = Number(r.top);
            this.childRight = Number(r.right);
            this.childBottom = Number(r.bottom);
        }
        else {
            this.childLeft = Number.MAX_VALUE;
            this.childTop = Number.MAX_VALUE;
            this.childRight = -Number.MAX_VALUE;
            this.childBottom = -Number.MAX_VALUE;
        }
    }
    /**
     * getPageBounds method\
     *
     * @returns { Rect }    getPageBounds method .\
     * @param {number} originX - provide the options value.
     * @param {number} originY - provide the options value.
     * @private
     */
    getPageBounds(originX, originY) {
        if (this.pageLeft === Number.MAX_VALUE) {
            return new Rect(0, 0, 0, 0);
        }
        const left = originX !== undefined ? Math.min(this.pageLeft, 0) : this.pageLeft;
        const top = originY !== undefined ? Math.min(this.pageTop, 0) : this.pageTop;
        return new Rect(Math.round(left), Math.round(top), Math.round(this.pageRight - left), Math.round(this.pageBottom - top));
    }
    /**
     * getQuad method\
     *
     * @returns { Quad }    getQuad method .\
     * @param {IGroupable} node - provide the options value.
     * @private
     */
    getQuad(node) {
        return this.quadTable[node.id];
    }
}
